import { IAccountMappingTemplateGroup } from '@modeso/types__aumico-lib-annualreport-be';
import { GatheringItems } from '../GatheringVisitor';

export class Group {
    constructor(public group: IAccountMappingTemplateGroup) {}

    accept(visitor: GatheringItems) {
        visitor.visitGroups(this.group);
    }
}
